import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import ModalCustom from '../../../modal-custom'
import { Button, Col, Form } from 'react-bootstrap'
import LabelCustom from '../../../label-custom'
import { createTeamsAPI } from '../../../../services/teams'
import Error_false from '../../../error/error-false'
import Error_500 from '../../../error/error-500'
import SwalCustom from '../../../../alert/swal-custom'
import { TXTSUCCESS } from '../../../../Constants'

const schema = yup
  .object({
    teamEn: yup.string().required('Please, Input team for English'),
    teamTh: yup.string().required('Please, Input team for Thai')
  })
  .required()
export default function AddTeam({
  param,
  setIsSave,
  showCreate,
  isSave,
  fnGetData,
  setShowCreate
}) {
  const {
    control,
    setValue,
    setError,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })

  const onSubmit = (d) => {
    const body = { ...param, ...d, larkEnable: d.larkEnable ?? false }

    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to create new?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2C5DFE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSave(true)
        createTeam(body)
      }
    })
  }

  const createTeam = async (body) => {
    try {
      const data = await createTeamsAPI(body)
      if (data?.status) {
        SwalCustom({
          title: `Success!`,
          text: TXTSUCCESS,
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          handleClose()
          fnGetData()
          fnReset()
        })
      } else {
        Error_false(data)
      }
      setIsSave(false)
    } catch (error) {
      Error_500(error)
      setIsSave(false)
    }
  }

  const fnReset = () => {
    setError('team_en', false)
    setError('team_th', false)
  }
  const handleClose = () => {
    setShowCreate(false)
    fnReset()
  }
  return (
    <ModalCustom width={500} open={showCreate} onCancel={handleClose}>
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="mt-3 row"
        style={{ rowGap: '13px' }}
      >
        <label>Add Team</label>

        <Col md={12}>
          <LabelCustom text={'Team EN'} />
          <Controller
            name={'teamEn'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control
                maxLength={100}
                value={value}
                onChange={onChange}
                // onKeyDown={handleKeyDownEN}
              />
            )}
          />
          {errors.teamEn?.message && (
            <label className="small text-danger">{errors.teamEn.message}</label>
          )}
        </Col>

        <Col md={12}>
          <LabelCustom text={'Team TH'} />
          <Controller
            name={'teamTh'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control
                maxLength={100}
                value={value}
                onChange={onChange}
                // onKeyDown={handleKeyDownTH}
              />
            )}
          />
          {errors.teamTh?.message && (
            <label className="small text-danger">{errors.teamTh.message}</label>
          )}
        </Col>
        <Col md={12}>
          <Controller
            name={'larkEnable'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Group
                className="mb-3"
                controlId="formBasicCheckbox"
                value={value}
                onChange={onChange}
              >
                <Form.Check
                  checked={value}
                  type="checkbox"
                  label="Lark Enable"
                />
              </Form.Group>
            )}
          />
        </Col>

        <Col xl={12} className="text-center">
          <Button className="px-4 " disabled={isSave} type="submit">
            {isSave ? 'Saving...' : 'Save'}
          </Button>
          <Button
            className="px-4 text-primary me-2"
            variant="light"
            type="button"
            disabled={isSave}
            onClick={handleClose}
          >
            Cancel
          </Button>
        </Col>
      </Form>
    </ModalCustom>
  )
}
